<script>

import CommonSubtitle from "../../CommonSubtitle/index.vue";
import CustomTextField from "../../CustomInput/CustomTextField.vue";
import CustomTextDropdown from "../../CustomInput/CustomDropdown.vue";
import CustomSelect from "../../global/CustomSelect/index.vue";
import CustomCheckbox from "../../global/CustomCheckBox/CheckBox.vue";
import CustomCheckboxGroup from "../../global/CustomCheckBox/CheckBoxGroup.vue";
import moment from "moment";
import DatePicker from "../../DatePicker/index.vue";
import {mapState} from "vuex";

export default {
  name: "DisabilityInfo",
  components: {
    CustomCheckboxGroup,
    CustomCheckbox,
    CustomSelect,
    CustomTextDropdown,
    CustomTextField,
    CommonSubtitle,
    DatePicker
  },
  props: {
    disabilityInfo: {
      type: Object,
      required: true
    },
    v$: {
      type: Object,
      required: true
    }
  },
  data() {
    const initial = {
      start: new Date(),
      end: new Date(),
    }
    return {
      initialDate: initial,
      selectedDisabilityOptions: [],
      disabilityOptions: [
        {value: '1', name: this.$t('kyc.disability_options.1')},
        {value: '2', name: this.$t('kyc.disability_options.2')},
        {value: '3', name: this.$t('kyc.disability_options.3')},
        {value: '4', name: this.$t('kyc.disability_options.4')},
        {value: '5', name: this.$t('kyc.disability_options.5')},
        {value: '0', name: this.$t('kyc.disability_options.0')},
      ],
    }
  },
  computed: {
    ...mapState('user', ['user', 'kycStatus'])
  },
  mounted() {
    if (this.user.disabilities.length > 0) {
      const disability = this.user.disabilities[0]
      this.disabilityInfo.is_disabled = true
      this.selectedDisabilityOptions = disability.disability.split(';')

      this.disabilityInfo.percent = String(disability.percent)
      this.disabilityInfo.start_date = disability.start_date
      this.disabilityInfo.end_date = disability.end_date
      this.initialDate = {start: new Date(disability.start_date), end: new Date(disability.end_date)}
    }
  },
  watch: {
    selectedDisabilityOptions() {
      this.disabilityInfo.disability = this.selectedDisabilityOptions.join(';')
    }
  },
  methods: {
    changeDate({start, end}) {
      this.disabilityInfo.start_date = moment(start).format('YYYY-MM-DD');
      this.disabilityInfo.end_date = moment(end).format('YYYY-MM-DD');
    },
  }
}
</script>

<template>
  <div>
    <div class="ml-4 mr-4">
      <CustomCheckbox v-model="disabilityInfo.is_disabled" :label="$t('kyc.disability')" class="ml-4 mb-4"/>
      <template v-if="disabilityInfo.is_disabled">
        <template class="ml-4">
          <h5 class="kyc-sub-title">{{ $t('kyc.disability_type') }}</h5>
          <CustomCheckboxGroup class="ml-2"
                               v-model="selectedDisabilityOptions"
                               :options="disabilityOptions"
                               :multiple="true"
          />
          <p v-if="v$?.disability.$error" class="error-message">{{ $t('kyc.at_least_one') }}</p>
        </template>

        <div class="row mt-4">
          <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <h5 class="kyc-sub-title">{{ $t('kyc.disability_percent') }}</h5>
            <CustomTextField :label="$t('kyc.percent')"
                             v-model="disabilityInfo.percent"
                             type="number"
                             percentage
                             :error="v$?.percent.$error"
                             :error-message="$t('kyc.between_0_100')"
            />
          </div>

          <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <h5 class="kyc-sub-title">{{ $t('kyc.disability_date') }}</h5>
            <div class="row">
              <DatePicker
                  :dates-prop="initialDate"
                  range
                  @change="changeDate"
              />
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<style scoped lang="scss">
.kyc-sub-title {
  font-size: 14px;
  font-weight: 500;
  color: var(primary-color-new);
}
</style>
